import React from 'react';
import { Select, Form, Flex } from 'antd';
import SyncIndicator from './SyncIndicator';

const SelectField = ({ field, value, onChange, disabled }) => {
	return (
		<Form.Item style={{ marginBottom: 8 }}>
			<Flex gap={8}>
							<Select
				value={value === null || value === undefined || value === '' ? undefined : value}
				onChange={(val) => onChange(val === null || val === undefined ? null : val)}
				placeholder="Выберите значение"
				style={{ width: '40%', minWidth: '200px' }}
				allowClear
				onClear={() => onChange(null)}
				disabled={disabled}
			>
				<Select.Option key="not_selected" value="">
					Не выбрано
				</Select.Option>
					{field.options?.map(option => (
						<Select.Option key={option.id} value={option.value}>
							{option.value}
						</Select.Option>
					))}
				</Select>
				<div style={{ lineHeight: '24px', display: 'flex', alignItems: 'center', gap: '8px' }}>
					{field.name}
					<SyncIndicator field={field} />
				</div>
			</Flex>
		</Form.Item>
	);
};

export default SelectField; 